/**
 * Gadget Connection Component
 * 
 * Web component that initializes the Gadget API client
 * Reads environment from data-gadget-environment attribute
 */

if (!customElements.get('gadget-connection')) {
  customElements.define(
    'gadget-connection',
    class GadgetConnection extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
        this.checkInterval = null;

        // DEV TEST CUSTOMER - also used in customizer
        this.testEmail = 'ocontis.web@gmail.com';
        this.testCustomerID = '23583389614456';
      }

      connectedCallback() {
        // Prevent double initialization
        if (this.initialized) {
          return;
        }
        this.initialized = true;
        this.init();

        window.customerEmail = this.testEmail;
        window.customerID = this.testCustomerID;
      }

      disconnectedCallback() {
        // Clean up interval if component is removed
        if (this.checkInterval) {
          clearInterval(this.checkInterval);
          this.checkInterval = null;
        }
      }

      get environment() {
        return this.dataset.gadgetEnvironment || 'production';
      }

      async init() {
        // Wait for Gadget script to load
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Check if Gadget is available
        if (typeof Gadget === 'undefined') {
          console.error('Gadget client failed to load');
          this.dispatchInitialized(false);
          return;
        }
        
        // Initialize Gadget client
        try {
          const gadgetEnvironment = this.environment.charAt(0).toUpperCase() + this.environment.slice(1);
          const gadgetAppUrl = this.environment.toLowerCase() === 'development' 
            ? 'https://scrumbles-quiz--development.gadget.app'
            : 'https://scrumbles-quiz.gadget.app';
          
          window.api = new Gadget({
            environment: gadgetEnvironment,
            // Some Gadget setups require the app URL
            appUrl: gadgetAppUrl
          });
          
          console.info('Gadget API initialized successfully');
          console.info('window.api:', window.api);
          console.info('window.api.petProfile:', window.api.petProfile);
          console.info('Available properties on window.api:', Object.keys(window.api || {}));
          
          // Check for common Gadget model access patterns
          // if (window.api) {
          //   console.info('Checking for petProfile model...');
          //   console.info('window.api.petProfile:', window.api.petProfile);
          //   console.info('window.api.petProfiles:', window.api.petProfiles);
          //   console.info('window.api.models:', window.api.models);
          //   console.info('window.api.model:', window.api.model);
            
          //   // Try to see if models are nested differently
          //   if (window.api.models) {
          //     console.info('Available models:', Object.keys(window.api.models || {}));
          //   }
          // }
          
          // Wait a bit for models to be available, then verify
          await new Promise(resolve => setTimeout(resolve, 200));
          
          // Verify petProfile model is available
          if (window.api && window.api.petProfile) {
            console.info('Gadget petProfile model is available');
            this.dispatchInitialized(true);
          } else {
            console.warn('Gadget API initialized but petProfile model not yet available');
            // Try polling for petProfile to become available
            this.pollForPetProfile();
          }
        } catch (error) {
          console.error('Error initializing Gadget API:', error);
          this.dispatchInitialized(false, error);
        }
      }

      pollForPetProfile() {
        let attempts = 0;
        const maxAttempts = 50; // 5 seconds total
        
        this.checkInterval = setInterval(() => {
          attempts++;
          if (window.api && window.api.petProfile) {
            clearInterval(this.checkInterval);
            this.checkInterval = null;
            console.info('Gadget petProfile model is now available');
            this.dispatchInitialized(true);
          } else if (attempts >= maxAttempts) {
            clearInterval(this.checkInterval);
            this.checkInterval = null;
            console.error('Gadget petProfile model failed to load after ' + maxAttempts + ' attempts');
            this.dispatchInitialized(false, 'petProfile model not available');
          }
        }, 100);
      }

      dispatchInitialized(success, error = null) {
        const event = new CustomEvent('gadgetInitialized', {
          detail: { success, error },
          bubbles: true
        });
        this.dispatchEvent(event);
        // Also dispatch on window for backward compatibility
        window.dispatchEvent(event);
      }
    }
  );
}
